import { render, staticRenderFns } from "./Home3.vue?vue&type=template&id=8f2e229a&scoped=true&"
import script from "./Home3.vue?vue&type=script&lang=js&"
export * from "./Home3.vue?vue&type=script&lang=js&"
import style0 from "./Home3.vue?vue&type=style&index=0&id=8f2e229a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2e229a",
  null
  
)

export default component.exports